class MotionElement extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    const motion = this.dataset.motion;
    const delay = parseInt(this.dataset.motionDelay) || 0;
    const hold = this.hasAttribute('hold');

    if (!motion) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            this.style.opacity = '1';
            this.style.transform = 'translateY(0)';
            this.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
          }, delay);

          if (!hold) {
            this.observer.disconnect();
          }
        } else if (hold) {
          this.style.opacity = '0';
          if (motion.includes('up')) {
            this.style.transform = 'translateY(40px)';
          } else if (motion.includes('down')) {
            this.style.transform = 'translateY(-40px)';
          }
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Initial state
    this.style.opacity = '0';
    if (motion.includes('up')) {
      this.style.transform = 'translateY(40px)';
    } else if (motion.includes('down')) {
      this.style.transform = 'translateY(-40px)';
    } else if (motion.includes('left')) {
      this.style.transform = 'translateX(-40px)';
    } else if (motion.includes('right')) {
      this.style.transform = 'translateX(40px)';
    }

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('motion-element')) {
  customElements.define('motion-element', MotionElement);
}
